import { Flex } from "@chakra-ui/react";
import React from "react";

interface Props {
  children: React.ReactNode;
}

const height = "16";
export const BottomBarWrapper: React.FC<Props> = ({ children }) => {
  return (
    <>
      <Flex h={height} mt="2"></Flex>
      <Flex
        h={height}
        w="100vw"
        left="0"
        pl="20"
        pr="14"
        boxShadow="0 -1px 5px rgba(0, 0, 0, 0.2)"
        zIndex={1003}
        justifyContent="flex-end"
        bg="white"
        bottom="0"
        pos="fixed"
        alignItems="center"
        gap={2}
      >
        {children}
      </Flex>
    </>
  );
};
